import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { IProject } from 'api/resources/projects';
import { getProjects } from 'api/resources/projects';
import { ECacheKeys } from 'cache/CacheKeys';
import URI from 'legacy/defaults/RoutesDefault';
import { isUserValid } from 'legacy/lib/api/utils/utils';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const useGetProjects = (
	filter = '',
	options?: UseQueryOptions<IProject[]>
) => {
	const navigate = useNavigate();
	const projectsQuery = useQuery<IProject[], unknown>({
		queryKey: [ECacheKeys.Projects, filter],
		queryFn: () => getProjects(filter),
		refetchInterval: false,
		refetchOnWindowFocus: false,
		retry: (_, error) => {
			return isUserValid(error);
		},
		meta: {
			error: 'There was an error fetching the projects, please try again',
		},
		...(options || {}),
	});

	useEffect(() => {
		if (!isUserValid(projectsQuery.error)) {
			navigate(URI.invalidInstance);
		}
	}, [projectsQuery.error, navigate]);

	return projectsQuery;
};
